import { P0, S, abs, fillAt, frac, max, rotPts, sq } from '../../geometry';

export const whale = {
  name: 'Whale',
  colors: ['#1FA2D6', '#3E63DD'],
  draw(m, t) {
    let tl = 5 * S(t * 1.6),
      sh = 5 + S(t * 2),
      spray = 0,
      so = 1,
      sp = 0.9,
      pose = P0();
    if (m === 'happy') {
      tl = 14 * S(t * 8);
      sh = 9 + 4 * abs(S(t * 6));
      spray = 1;
      sp = 1.6;
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: the blowhole keeps fountaining, droplets arcing out and falling.
    if (m === 'thinking') {
      sh = 12 + 4 * S(t * 4);
      spray = 1;
      tl = 7 * S(t * 1.8);
    }
    if (m === 'talking') sh = 4 + 6 * max(0, S(t * 10));
    if (m === 'surprised') {
      sh = 16;
      tl = -18;
      pose.ty = -2;
    }
    if (m === 'paused') {
      sh = 0.5;
      so = 0;
      tl = 14 + S(t * 0.8);
      pose.ty = 2;
      pose.sy = 0.95;
    }
    const tail = rotPts(
        [
          [60, 74],
          [76, 73],
          [84, 61],
        ],
        60,
        74,
        -tl
      ),
      fluke = rotPts(
        [
          [84, 63],
          [76, 53],
          [84, 57],
          [93, 52],
          [84, 63],
        ],
        60,
        74,
        -tl
      );
    const top = 43 - sh,
      sx = 39;
    const drops = [0, 1, 2, 3].map((k) => {
      const f = frac(t * sp + k / 4),
        d = k % 2 ? 1 : -1,
        x = sx + d * (5 + 13 * f),
        y = top - 6 * S(Math.PI * f) + 16 * f * f;
      return {
        c: 'b',
        pts: [
          [x, y],
          [x + 0.01, y],
        ],
        snap: true,
        o: spray * S(Math.PI * f),
        detail: true,
      };
    });
    return {
      strokes: [
        { c: 'a', pts: tail },
        { c: 'a', pts: fluke, sharp: true, n: 30 },
        { c: 'a', pts: sq(44, 63, 27, 19, 2.4), n: 30 },
        {
          c: 'b',
          pts: [
            [sx, 43],
            [sx, top],
          ],
          o: so,
        },
        {
          c: 'b',
          pts: [
            [sx, top],
            [sx - 6, top - 3],
            [sx - 10, top + 2],
          ],
          o: so,
        },
        {
          c: 'b',
          pts: [
            [sx, top],
            [sx + 6, top - 3],
            [sx + 10, top + 2],
          ],
          o: so,
        },
        ...drops,
      ],
      eyes: { x: 38, y: 61 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 1, 2),
};
